import React, {useContext, useEffect, useState} from "react";
import * as Constants from "./util/Constants";
import * as Helpers from "./util/Helpers";
import "./assets/styles.css";
import { useGlobalneVarijable } from "hooks/useGlobalneVarijable";
import Grupa from "./types/Grupa";

const Navigacija = () => {
    const [data, setData] = useState<Grupa[]>();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { grupaSifra, setGrupaSifra, robaSifra, setRobaSifra } = useGlobalneVarijable();


    useEffect(() => {
        fetch("https://rodendaonica.com/get_data.php",
            {
                method: "POST",
                headers:{
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(
                    {
                        Funkcija:"p_Grupa_SveNadgrupe",
                        Grupa:grupaSifra

                    }),
            }
        )

            .then((response) => {
                if (!response.ok) {
                    throw new Error("Greška pri dohvaćanju podataka");
                }
                return response.json();
            })
            .then((json) => {
                setData(json);
                setLoading(false);
            })
            .catch((err) => {
                setError(err.message);
                setLoading(false);
            });
    }, [grupaSifra,setGrupaSifra]);


    if (loading) {
        return <p>Učitavanje:</p>;
    }

    if (error) {
        return <p style={{ color: "red" }}>{error}</p>;
    }


    return (

        <div className={"popis-navigacija"}>
            <div className={"navigacija-container"}>
            {data && data.map((item:Grupa) => (
                <div className={"navigacija"} key={"Grupa"+item.GrupaSifra} onClick={() => Helpers.OdaberiGrupu(item.GrupaSifra,setGrupaSifra)}>Nadgrupa {item.GrupaSifra}</div>
            ))}
            </div>
        </div>
    );

};


export default Navigacija;
